import { type } from 'os';
import { MapTarget } from './map-target.model';

export class MapNode {
  id: string = null;
  label: string = null;
  thematicClassification = -1;
  score = 0.0;
  nodesLinked: Array<string> = new Array<string>();
  setNodesLinked: Set<string> = new Set<string>();
  targetNodes: Array<MapTarget> = new Array<MapTarget>();
  data: any = null;
  rank = 0;
  isMain = false;
  isJoint = false;

  //spoc
  allFundingAmount = 0;
  fundingRoundAmount = 0;
  weight = 0;
  type = '';
  hoverLabel: string = null;
  announcedDate: string = null;
  sizeFactor = 1;

  constructor(element: any) {
    if (element) {
      this.id = element.id;
      this.label = element.label;
      this.nodesLinked = element.linkedNodes
        ? element.linkedNodes.map(x => new String(x).toString())
        : element.nodesLinked
        ? element.nodesLinked.map(x => new String(x).toString())
        : new Array<string>();
      this.setNodesLinked = element.setNodesLinked ? new Set(element.setNodesLinked) : new Set<string>();
      this.nodesLinked.forEach(linked => this.setNodesLinked.add(linked));
      this.data = Object.assign({}, element.data);
      this.isMain = element.mainNode ? element.mainNode : element.isMain;
      if (element.thematicClassification > -1) {
        this.thematicClassification = element.thematicClassification;
      } else if (element.isMain) {
        this.thematicClassification = 0;
      }
      this.rank = element.rank;
      this.targetNodes = element.targetNodes ? element.targetNodes.map(x => new MapTarget(x)) : new Array<MapTarget>();
      this.isJoint = element.isJoint;

      this.weight = element.weight;
      this.type = element.type;
      this.fundingRoundAmount = element.fundingRoundAmount;
      this.allFundingAmount = element.allFundingAmount;
      this.hoverLabel = element.hoverLabel;
      this.announcedDate = element.announcedDate;
      this.sizeFactor = element.sizeFactor ? element.sizeFactor : 1;
    }
  }

  update(element: any) {
    this.label = element.label;
    this.nodesLinked = element.linkedNodes
      ? element.linkedNodes.map(x => new String(x).toString())
      : element.nodesLinked
      ? element.nodesLinked.map(x => new String(x).toString())
      : new Array<string>();
    this.setNodesLinked = element.setNodesLinked ? new Set(element.setNodesLinked) : new Set<string>();
    this.nodesLinked.forEach(linked => this.setNodesLinked.add(linked));
    this.data = Object.assign({}, element.data);
    if (element.thematicClassification > -1) {
      this.thematicClassification = element.thematicClassification;
    } else if (element.isMain) {
      this.thematicClassification = 0;
    }

    this.isMain = element.isMain;
    this.score = element.score;
    this.rank = element.rank;
    this.targetNodes = element.targetNodes ? element.targetNodes.map(x => new MapTarget(x)) : new Array<MapTarget>();
  }

  updatefromBackEnd(element: any) {
    this.label = element.label;
    this.nodesLinked = element.linkedNodes
      ? element.linkedNodes.map(x => new String(x).toString())
      : element.nodesLinked
      ? element.nodesLinked.map(x => new String(x).toString())
      : new Array<string>();
    this.setNodesLinked = element.setNodesLinked ? new Set(element.setNodesLinked) : new Set<string>();
    this.nodesLinked.forEach(linked => this.setNodesLinked.add(linked));
    this.data = Object.assign({}, element.data);
    this.targetNodes = element.targetNodes ? element.targetNodes.map(x => new MapTarget(x)) : new Array<MapTarget>();
  }
}
